import React from 'react';
import i18next from 'i18next';
import en from 'app/main/pages/auth/i18n/en';
import jp from 'app/main/pages/auth/i18n/jp';

i18next.addResourceBundle('en', 'auth', en);
i18next.addResourceBundle('jp', 'auth', jp);

const LoginPageConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/pages/auth/login',
			component: React.lazy(() => import('./LoginPage'))
		}
	]
};

export default LoginPageConfig;
